export var navBarHeaderContainer = function navBarHeaderContainer(theme) {
  return {
    borderBottom: "1px solid ".concat(theme.gray150),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 2.4em',
    position: 'sticky',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    minHeight: '6rem',
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    backgroundColor: theme.mode === 'dark' ? 'rgba(13, 21, 38, 0.92)' : 'rgba(255, 255, 255, 0.92)',
    gap: '1rem',
    '@media (max-width: 767px)': {
      padding: '0 1.2em',
      minHeight: '5.4rem'
    }
  };
};
export var navBarLeftSideContainer = function navBarLeftSideContainer(theme) {
  return {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    minWidth: 0,
    flex: 1,
    '& h5': {
      fontWeight: 600,
      color: theme.gray800,
      fontSize: '1.6rem',
      letterSpacing: '-0.01em',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      minWidth: 0,
      '@media (max-width: 767px)': {
        fontSize: '1.4rem'
      }
    }
  };
};
export var navBarRightSideContainer = function navBarRightSideContainer() {
  return {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    gap: '0.8rem',
    flexShrink: 0,
    '& .nav-office-dropdown': {
      minWidth: 200,
      '@media (max-width: 1023px)': {
        minWidth: 160
      },
      '@media (max-width: 767px)': {
        minWidth: 120,
        maxWidth: 140
      },
      '@media (max-width: 479px)': {
        display: 'none'
      }
    }
  };
};
export var hamburgerButton = function hamburgerButton(theme) {
  return {
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    width: '3.6rem',
    height: '3.6rem',
    flexShrink: 0,
    marginRight: '0.4rem',
    cursor: 'pointer',
    color: theme.gray500,
    border: "1px solid ".concat(theme.gray200),
    backgroundColor: theme.white,
    transition: 'all 0.2s ease',
    '&:hover': {
      color: theme.primary,
      borderColor: theme.primary,
      backgroundColor: theme.primaryLight
    },
    '& i': {
      fontSize: '1.8rem',
      lineHeight: 1
    },
    '@media (max-width: 767px)': {
      display: 'flex'
    }
  };
};
export var logoutText = {
  '@media (max-width: 767px)': {
    display: 'none'
  }
};
export var logoutIcon = {
  fontSize: '1.6rem',
  lineHeight: 1,
  display: 'none',
  '@media (max-width: 767px)': {
    display: 'block'
  }
};
export var themeToggleButton = function themeToggleButton(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '3.6rem',
    height: '3.6rem',
    flexShrink: 0,
    cursor: 'pointer',
    color: theme.gray500,
    border: "1px solid ".concat(theme.gray200),
    backgroundColor: theme.white,
    transition: 'all 0.2s ease',
    '&:hover': {
      color: theme.primary,
      borderColor: theme.primary
    },
    '& i': {
      fontSize: '1.6rem'
    }
  };
};